<script>
import ModalCourseComponent from '../../features/modals/ModalCourseComponent';
import ModalCourseSectionView from './ModalCourseSectionView.vue';
import draggable from 'vuedraggable';

export default {
  name: 'ModalCourseView',
  components: {
    'modal-course-section-view': ModalCourseSectionView,
    draggable,
  },
  extends: ModalCourseComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Curso"
      width="75%"
      class="course-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <div class="course-stepper-wrapper">
          <el-steps
            :active="currentStep"
            finish-status="success"
            align-center
            class="course-steps"
          >
            <el-step
              title="Información General"
              description="Datos principales"
              @click="goToStep(0)"
            />
            <el-step
              title="Vista"
              description="Portada y multimedia"
              @click="goToStep(1)"
            />
            <el-step
              title="Contenido del Curso"
              description="Módulos y lecciones"
              @click="goToStep(2)"
            />
            <el-step
              title="Profesores"
              description="Asignación docente"
              @click="goToStep(3)"
            />
          </el-steps>
        </div>

        <div class="course-step-content">
          <div
            id="tab_step1"
            v-show="currentStep === 0"
            class="step-tab-panel step-tab-info active"
          >
                <div class="tab-from-content">
                  <div class="title-icon">
                    <h3 class="title">
                      <i class="uil uil-info-circle" />Informaci&oacute;n
                      General
                    </h3>
                  </div>
                  <fieldset>
                    <el-row
                      class="row-bg"
                      :gutter="20"
                    >
                      <el-col
                        :xs="24"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                      >
                        <el-form-item
                          label="Categoria"
                          prop="courseCategory"
                        >
                          <el-select
                            v-model="formData.courseCategory"
                            filterable
                            placeholder="Seleccionar"
                            value-key="id"
                            size="small"
                          >
                            <el-option
                              v-for="item in courseCategories"
                              :key="item.id"
                              :label="item.name"
                              :value="item"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :xs="24"
                        :sm="16"
                        :md="16"
                        :lg="16"
                        :xl="16"
                      >
                        <el-form-item
                          label="Universidad"
                          prop="university"
                        >
                          <el-select
                            v-model="formData.university"
                            filterable
                            placeholder="Seleccionar"
                            value-key="id"
                            size="small"
                            @change="onChangeUniversity"
                          >
                            <el-option
                              v-for="item in universities"
                              :key="item.id"
                              :label="item.name"
                              :value="item"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row
                      class="row-bg"
                      :gutter="20"
                    >
                      <el-col
                        :xs="24"
                        :sm="5"
                        :md="5"
                        :lg="5"
                        :xl="5"
                      >
                        <el-form-item
                          label="Código"
                          prop="code"
                        >
                          <el-input
                            v-model="formData.code"
                            size="small"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col
                        :xs="24"
                        :sm="19"
                        :md="19"
                        :lg="19"
                        :xl="19"
                      >
                        <el-form-item
                          label="Titulo"
                          prop="title"
                        >
                          <el-input
                            v-model="formData.title"
                            maxlength="175"
                            size="small"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row
                      class="row-bg"
                      :gutter="20"
                    >
                      <el-col
                        :xs="24"
                        :sm="15"
                        :md="15"
                        :lg="15"
                        :xl="15"
                      >
                        <el-form-item
                          label="Descripción"
                          prop="description"
                        >
                          <el-input
                            v-model="formData.description"
                            maxlength="255"
                            size="small"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col
                        :xs="24"
                        :sm="5"
                        :md="5"
                        :lg="5"
                        :xl="5"
                      >
                        <el-form-item
                          label="¿Comentarios Disponibles?"
                          prop="isPublished"
                          align="center"
                        >
                          <el-switch
                            v-model="formData.commentsAvailable"
                            style="display: block"
                            active-color="#13ce66"
                            inactive-text="No"
                            active-text="Si"
                            :inactive-value="false"
                            :active-value="true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col
                        :xs="24"
                        :sm="4"
                        :md="4"
                        :lg="4"
                        :xl="4"
                      >
                        <el-form-item
                          label="Publicar"
                          prop="isPublished"
                          align="center"
                        >
                          <el-switch
                            v-model="formData.isPublished"
                            style="display: block"
                            active-color="#13ce66"
                            inactive-text="No"
                            active-text="Si"
                            :inactive-value="false"
                            :active-value="true"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row
                      type="flex"
                      class="row-bg"
                      :gutter="20"
                    >
                      <el-col :span="24">
                        <el-form-item
                          label="Acerca de"
                          prop="tags"
                        >
                          <el-input
                            v-model="formData.about"
                            type="textarea"
                            class="about-editor"
                            :row="3"
                            maxlength="255"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      class="row-bg"
                      :gutter="20"
                    >
                      <el-col :span="24">
                        <el-form-item
                          label="Etiquetas"
                          prop="tags"
                        >
                          <el-tag
                            v-for="tag in dynamicTags"
                            :key="tag"
                            effect="plain"
                            closable
                            :disable-transitions="false"
                            @close="handleTagClose(tag)"
                          >
                            {{ tag }}
                          </el-tag>
                          <div>
                            <el-input
                              v-if="inputTagsVisible"
                              ref="saveTagInput"
                              v-model="inputTagsValue"
                              placeholder="Ingresar etiqueta"
                              class="input-new-tag"
                              size="small"
                              @blur="handleTagConfirm"
                            >
                              <template #append>
                                <el-button
                                
                                  type="primary"
                                  size="small"
                                  icon="el-icon-plus"
                                  @click="handleTagConfirm"
                                />
                              </template>
                            </el-input>
                            <el-button
                              v-else
                              type="primary"
                              class="btn-primary button-new-tag"
                              size="small"
                              @click="showTagInput"
                            >
                              + Agregar
                            </el-button>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>
                </div>
              </div>

          <div
            id="tab_step2"
            v-show="currentStep === 1"
            class="step-tab-panel step-tab-gallery active"
          >
                <div class="tab-from-content">
                  <div class="title-icon">
                    <h3 class="title">
                      <i class="uil uil-image-upload" />Vista
                    </h3>
                  </div>
                  <div class="course__form">
                    <div class="view_info10">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="view_all_dt">
                            <el-row
                              class="row-bg"
                              :gutter="20"
                            >
                              <el-col
                                :xs="24"
                                :sm="10"
                                :md="10"
                                :lg="10"
                                :xl="10"
                              >
                                <div class="view__img">
                                  <img
                                    :src="coverImageUrl"
                                    alt=""
                                  >
                                </div>
                              </el-col>
                              <el-col
                                :xs="24"
                                :sm="12"
                                :md="14"
                                :lg="14"
                                :xl="14"
                              >
                                <div class="view_info_right">
                                  <h4>Imagen de Portada</h4>
                                  <p>
                                    Subir imagen del curso aquí. Debes conocer
                                    nuestro estandar de calidad para las
                                    imagenes de portada de cursos aceptadas.
                                    Formato Importante: 750x422 pixeles; .jpg,
                                    .jpeg,. gif, or .png. imagen sin texto.
                                  </p>
                                  <div class="upload__input">
                                    <div class="input-group">
                                      <div class="custom-file">
                                        <el-form-item prop="coverImage">
                                          <el-upload
                                            v-if="
                                              !isCoverImageTemp &&
                                                !formData.coverImageUrl
                                            "
                                            class="file-uploader"
                                            :name="'coverImageFileUploader'"
                                            action
                                            :on-success="
                                              onSuccessUploadCoverImage
                                            "
                                            :before-upload="
                                              onBeforeUploadCoverImage
                                            "
                                            :show-file-list="false"
                                            :data="coverImageFile"
                                          >
                                            <el-button
                                              size="small"
                                              type="primary"
                                              class="btn-primary"
                                            >
                                              Clic para subir
                                              archivo
                                            </el-button>
                                          </el-upload>
                                          <p
                                            v-if="
                                              isCoverImageTemp ||
                                                formData.coverImageUrl
                                            "
                                          >
                                            <br>
                                            <el-button
                                              size="small"
                                              type="primary"
                                              class="btn-primary"
                                              @click="onRemoveCoverImage"
                                            >
                                              <i
                                                class="el-icon-circle-close"
                                              />
                                              Eliminar
                                            </el-button>
                                          </p>
                                        </el-form-item>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                            <!--
                            <div class="view_img_left">
                              <div class="view__img">
                                <img :src="coverImageUrl" alt="" />
                              </div>
                            </div>
                            <div class="view_img_right">
                              <h4>Imagen de Portada</h4>
                              <p>
                                Subir imagen del curso aquí. Debes conocer nuestro estandar de calidad 
                                para las imagenes de portada de cursos aceptadas.
                                Formato Importante: 750x422 pixeles; .jpg,
                                .jpeg,. gif, or .png. imagen sin texto.
                              </p>
                              <div class="upload__input">
                                <div class="input-group">
                                  <div class="custom-file">
                                    <el-form-item prop="coverImage">
                                        <el-upload
                                          class="file-uploader"
                                          :name="'coverImageFileUploader'"
                                          v-if="!isCoverImageTemp && !formData.coverImageUrl"
                                          action
                                          :on-success="onSuccessUploadCoverImage"
                                          :before-upload="onBeforeUploadCoverImage"
                                          :show-file-list="false"
                                          :data="coverImageFile"
                                        >
                                          <el-button size="small" type="primary" class="btn-primary">Clic para subir archivo</el-button>
                                        </el-upload>
                                        <p v-if="isCoverImageTemp || formData.coverImageUrl">
                                          <br/>
                                          <el-button size="small" type="primary" class="btn-primary" @click="onRemoveCoverImage"><i class="el-icon-circle-close"></i> Eliminar</el-button>
                                        </p>
                                      </el-form-item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            -->
                          </div>
                          <div class="view_all_dt">
                            <el-row
                              class="row-bg"
                              :gutter="20"
                            >
                              <el-col
                                :xs="24"
                                :sm="10"
                                :md="10"
                                :lg="10"
                                :xl="10"
                              >
                                <div class="view__img">
                                  <img
                                    v-if="!formData.promotionalVideoUrl"
                                    src="/images/courses/add_video.jpg"
                                    alt=""
                                  >
                                  <iframe
                                    v-if="formData.promotionalVideoUrl"
                                    :src="formData.promotionalVideoUrl"
                                    width="500"
                                    height="250"
                                    frameborder="0"
                                    allow="autoplay; fullscreen; unload"
                                    allowfullscreen
                                    style="width:100%"
                                  />
                                </div>
                              </el-col>
                              <el-col
                                :xs="24"
                                :sm="12"
                                :md="14"
                                :lg="14"
                                :xl="14"
                              >
                                <div class="view_info_right">
                                  <h4>Video Promocional</h4>
                                  <p>
                                    Estudiantes que ven videos promocionales
                                    bien hechos, tienen más probabilidades de
                                    inscribirse al curso. Hemos visto distintas
                                    estadísticas y el crecimiento es
                                    impresionante!
                                  </p>
                                  <div class="upload__input">
                                    <div class="input-group">
                                      <div class="custom-file">
                                        <div
                                          class="ui left icon mt-50"
                                          style="width:100%;"
                                        >
                                          <el-form-item
                                            prop="promotionalVideoUrl"
                                            style="width:100%;"
                                          >
                                            <el-input
                                              v-model="
                                                formData.promotionalVideoUrl
                                              "
                                              :value="
                                                formData.promotionalVideoUrl
                                              "
                                              type="textarea"
                                              :row="2"
                                            />
                                          </el-form-item>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                            <!--
                            <div class="view_img_left">
                              <div class="view__img">
                                <img src="/images/courses/add_video.jpg" alt="" v-if="!formData.promotionalVideoUrl"/>
                                <iframe v-if="formData.promotionalVideoUrl"
                                :src="formData.promotionalVideoUrl" width="500" height="250" frameborder="0" allow="autoplay; fullscreen; unload" allowfullscreen
                                style="width:100%"></iframe>
                              </div>
                            </div>
                            <div class="view_img_right">
                              <h4>Video Promocional</h4>
                              <p>
                                Estudiantes que ven videos promocionales bien hechos, tienen más probabilidades de inscribirse al curso. 
                                Hemos visto distintas estadísticas y el crecimiento es impresionante!
                              </p>
                              <div class="upload__input">
                                <div class="input-group">
                                  <div class="custom-file">
                                    <div class="ui left icon mt-50" style="width:100%;">
                                      <el-form-item prop="promotionalVideoUrl" style="width:100%;">
                                          <el-input v-model="formData.promotionalVideoUrl" :value="formData.promotionalVideoUrl" type="textarea" :row="2"></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          <div
            id="tab_step3"
            v-show="currentStep === 2"
            class="step-tab-panel step-tab-location active"
          >
                <div class="tab-from-content">
                  <div class="course-section-header">
                    <div class="title-icon">
                      <h3 class="title">
                        <i class="uil uil-film" />Contenido de Curso
                      </h3>
                    </div>
                    <el-button
                      type="primary"
                      size="small"
                      class="btn-primary"
                      icon="el-icon-circle-plus"
                      :disabled="!onCanCreateCourseSection(modulePermissions)"
                      @click="onCreateCourseSection"
                    >
                      Agregar Sección
                    </el-button>
                  </div>

                  <el-alert
                    v-if="!formData.university"
                    title="Para agregar secciones es necesario seleccionar una Universidad en el paso de Información General."
                    type="warning"
                    show-icon
                    :closable="false"
                    class="course-university-alert"
                  />

                  <div class="course-sections-wrapper mt-20">
                    <!-- Empty State -->
                    <div
                      v-if="!hasVisibleCourseSections()"
                      class="course-sections-empty"
                    >
                      <el-empty
                        :image-size="70"
                        description="No hay secciones agregadas en este curso todavía."
                      >
                        <el-button
                          type="primary"
                          size="small"
                          class="btn-primary"
                          icon="el-icon-circle-plus"
                          :disabled="!onCanCreateCourseSection(modulePermissions)"
                          @click="onCreateCourseSection"
                        >
                          Agregar Primera Sección
                        </el-button>
                      </el-empty>
                    </div>

                    <!-- Sections Table -->
                    <div
                      v-else
                      class="course-sections-table"
                    >
                      <div class="sections-table-head">
                        <div class="th-col col-sort">ORDEN</div>
                        <div class="th-col col-title">TÍTULO</div>
                        <div class="th-col col-specialty">¿ESPECIALIDAD?</div>
                        <div class="th-col col-topics">TEMAS</div>
                        <div class="th-col col-actions">OPCIONES</div>
                      </div>

                      <draggable
                        v-model="formData.courseSections"
                        item-key="sort"
                        handle=".drag-handle"
                        ghost-class="ghost-section-row"
                        @change="onChangeCourseSectionDrag"
                      >
                        <template #item="{ element, index }">
                          <div
                            v-show="element.updateState !== formData.UPDATE_STATUS.REMOVED"
                            :key="element.sort || index"
                            class="sections-table-row"
                          >
                            <!-- Orden / Drag Handle -->
                            <div class="td-col col-sort">
                              <i
                                class="fa fa-grip-vertical drag-handle"
                                title="Arrastrar para ordenar"
                              />
                              <span class="order-badge">{{ element.sort }}</span>
                            </div>

                            <!-- Título -->
                            <div class="td-col col-title">
                              <span class="section-title-text">{{ element.title }}</span>
                              <span
                                v-if="element.description"
                                class="section-desc-text"
                              >{{ element.description }}</span>
                            </div>

                            <!-- Especialidad / Carreras -->
                            <div class="td-col col-specialty">
                              <el-popover
                                v-if="element.isSpecialty"
                                placement="bottom"
                                :width="320"
                                trigger="click"
                              >
                                <el-table
                                  :data="element.specialties || []"
                                  size="small"
                                  border
                                  empty-text="Sin carreras asociadas"
                                >
                                  <el-table-column
                                    min-width="260"
                                    property="name"
                                    label="Carreras Asignadas"
                                  />
                                </el-table>
                                <template #reference>
                                  <el-tag
                                    size="small"
                                    type="success"
                                    effect="light"
                                    class="specialty-badge cursor-pointer"
                                  >
                                    <i class="fa fa-graduation-cap" />
                                    Especialidad ({{ (element.specialties && element.specialties.length) || 0 }})
                                  </el-tag>
                                </template>
                              </el-popover>
                              <el-tag
                                v-else
                                size="small"
                                type="info"
                                effect="plain"
                              >
                                General
                              </el-tag>
                            </div>

                            <!-- Temas -->
                            <div class="td-col col-topics">
                              <el-tag
                                size="small"
                                type="primary"
                                effect="plain"
                              >
                                <i class="fa fa-book" />
                                {{ element.getTotalCourseSubjects ? element.getTotalCourseSubjects() : 0 }} temas
                              </el-tag>
                            </div>

                            <!-- Opciones -->
                            <div class="td-col col-actions">
                              <el-dropdown
                                trigger="click"
                                @command="onChangeItemOptions"
                              >
                                <el-button
                                  size="small"
                                  class="btn-row-action"
                                >
                                  <i class="fa fa-ellipsis-v" />
                                </el-button>
                                <template #dropdown>
                                  <el-dropdown-menu>
                                    <el-dropdown-item
                                      :command="{
                                        command: 'edit',
                                        item: element,
                                        index: index,
                                      }"
                                      :disabled="
                                        !onCanReadCourseSection(
                                          modulePermissions
                                        )
                                      "
                                    >
                                      <i class="el-icon-edit" />
                                      Mostrar
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                      :command="{
                                        command: 'delete',
                                        item: element,
                                        index: index,
                                      }"
                                      :disabled="
                                        !onCanDeleteCourseSection(
                                          modulePermissions
                                        )
                                      "
                                      divided
                                    >
                                      <i class="el-icon-delete" />
                                      Eliminar
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </template>
                              </el-dropdown>
                            </div>
                          </div>
                        </template>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>

          <div
            id="tab_step4"
            v-show="currentStep === 3"
            class="step-tab-panel step-tab-amenities active"
          >
                <div class="tab-from-content">
                  <div class="title-icon">
                    <h3 class="title">
                      <i class="uil uil-file-copy-alt" />Profesores
                    </h3>
                  </div>
                  <div>
                    <div class="row">
                      <div class="col-lg-12">
                        <el-select
                          v-model="instructorSelected"
                          filterable
                          remote
                          placeholder="Buscar por nombre y seleccionar resultado para agregar"
                          :remote-method="onSearchInstructors"
                          @change="onSelectInstructor"
                        >
                          <el-option
                            v-for="item in instructors"
                            :key="item.id"
                            :label="item.getFullName()"
                            :value="item"
                          />
                        </el-select>
                      </div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-lg-12">
                        <el-table
                          :data="formData.instructors"
                          empty-text="No se encontraron resultados."
                        >
                          <el-table-column
                            label=""
                            width="80"
                          >
                            <template #default="scope">
                              <div>
                                <el-avatar
                                  :src="
                                    mapInstructorImage(scope.row.userProfile)
                                  "
                                />
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="NOMBRE DEL PROFESOR"
                            min-width="300"
                          >
                            <template #default="scope">
                              <div v-if="scope.row.getFullName">
                                {{ scope.row.getFullName() }}
                              </div>
                            </template>
                          </el-table-column>

                          <el-table-column
                            label="OPCIONES"
                            :width="120"
                            align="center"
                            text-align="center"
                          >
                            <template #default="scope">
                              <el-button-group>
                                <el-button
                                  size="small"
                                  class="btn-cancel"
                                  @click="onRemoveInstructor(scope.$index)"
                                >
                                  <i
                                    class="el-icon-delete"
                                    aria-hidden="true"
                                  />
                                </el-button>
                              </el-button-group>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </el-form>
      <template #footer>
        <div class="course-modal-footer">
          <div class="footer-left">
            <el-button
              size="small"
              class="btn-cancel"
              @click="onCancel"
            >
              Cancelar
            </el-button>
          </div>
          <div class="footer-right">
            <el-button
              v-if="formData.id && currentStep < 3"
              size="small"
              class="btn-primary-light"
              :disabled="!onCanSaveOrUpdate()"
              @click="onSubmitForm('formData')"
            >
              Guardar cambios
            </el-button>
            <el-button
              v-if="currentStep > 0"
              size="small"
              class="steps_btn btn-prev"
              icon="el-icon-arrow-left"
              @click="goToStep(currentStep - 1)"
            >
              Anterior
            </el-button>
            <el-button
              v-if="currentStep < 3"
              type="primary"
              size="small"
              class="steps_btn btn-next"
              @click="goToStep(currentStep + 1)"
            >
              Siguiente <i class="el-icon-arrow-right el-icon--right" />
            </el-button>
            <el-button
              v-if="currentStep === 3"
              type="primary"
              size="small"
              class="steps_btn btn-finish"
              icon="el-icon-check"
              :disabled="!onCanSaveOrUpdate()"
              @click="onSubmitForm('formData')"
            >
              Finalizar
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <modal-course-section-view
      v-if="modalItemCourseSection.isVisible"
      :form-data="itemCourseSection"
      :conf="modalItemCourseSection"
    />
  </div>
</template>
